export const PIN_VIDEO = Symbol('PIN_VIDEO');
export const UNPIN_VIDEO = Symbol('UNPIN_VIDEO');
export const SAVED_VIDEOS_FETCH_SUCCESS = Symbol('SAVED_VIDEOS_FETCH_SUCCESS');
export const REQUEST_SAVED_VIDEOS_COLLECTION = Symbol('REQUEST_SAVED_VIDEOS_COLLECTION');
export const REQUEST_SAVED_VIDEOS_MOBILE_COLLECTION = Symbol('REQUEST_SAVED_VIDEOS__MOBILE_COLLECTION');

/**
 * @param savedVideos
 * @returns {{type: symbol, payload: {videoId: *}}}
 */
export const savedVideosSuccessAction = (savedVideos) => ({
  type: SAVED_VIDEOS_FETCH_SUCCESS,
  payload: {
    savedVideos,
  },
});

export const pinVideoAction = (payload) => ({
  type: PIN_VIDEO,
  payload,
});

export const unpinVideoAction = (payload) => ({
  type: UNPIN_VIDEO,
  payload,
});

/**
 * @param {number} userId
 * @param {string} sortingKey
 * @param {string} sortingOrder
 * @returns {{type: symbol, payload: {userId: *,sortingKey, sortingOrder}}}
 */
export const requestSavedVideosCollectionAction = (userId, perPage, pageNumber, sort) => ({
  type: REQUEST_SAVED_VIDEOS_COLLECTION,
  payload: {
    userId,
    perPage,
    pageNumber,
    sort,
  },
});

export const requestSavedVideosMobileCollectionAction = (userId, perPage, pageNumber, prevVideos, sort) => ({
  type: REQUEST_SAVED_VIDEOS_MOBILE_COLLECTION,
  payload: {
    userId,
    perPage,
    pageNumber,
    prevVideos,
    sort,
  },
});
